import Notify from "config/notify";
import apiClient from "config/apiClient";
import type { IUpsertUserRequest, UserListRequest } from "../types/user";

const API_LIST_URL = `${process.env.REACT_APP_API_URL}/mst/user/select`;
const API_UPDATE_URL = `${process.env.REACT_APP_API_URL}/mst/user/update`;
const API_CREATE_URL = `${process.env.REACT_APP_API_URL}/mst/user/create`;
const API_SUGGEST_CODE_URL = `${process.env.REACT_APP_API_URL}/mst/user/type/code/select`;

const handleError = (message: string, error: any) => {
  console.error(message, error);
};

/**
 * Retrieve users
 * @param {UserListRequest} data
 * @returns {Promise<any>}
 */
const fetchUsersApi = async (data?: UserListRequest): Promise<any> => {
  try {
    const response = await apiClient.post(`${API_LIST_URL}`, data);
    return response.data;
  } catch (error) {
    handleError("Error fetching users:", error);
    throw error;
  }
};

/**
 * Update user
 * @param {IUpsertUserRequest} data
 * @returns {Promise<any>}
 */
const updateUserApi = async (data: IUpsertUserRequest): Promise<any> => {
  try {
    const response = await apiClient.post(`${API_UPDATE_URL}`, data);
    if (response.status === 200) {
      Notify.setNotification({
        show: true,
        title: "更新が完了しました",
        confirmLabel: "OK",
        actionsPosition: "center",
      });
    } else {
      throw new Error(response.message);
    }
    return response;
  } catch (error) {
    handleError("Error fetching users:", error);
    throw error;
  }
};

/**
 * Create user
 * @param {IUpsertUserRequest} data
 * @returns {Promise<any>}
 */
const createUserApi = async (data: IUpsertUserRequest): Promise<any> => {
  const response = await apiClient.post(`${API_CREATE_URL}`, data);
  if (response.status === 200) {
    Notify.setNotification({
      show: true,
      title: "登録が完了しました",
      message: "",
    });
    return response.data;
  }
  throw new Error(response.message);
};

/**
 * Fetch suggest code for user type
 * @param {object} data - Contains user_type
 * @returns {Promise<any>}
 */
const fetchSuggestCodeApi = async (data: { user_type: string }): Promise<any> => {
  try {
    const response = await apiClient.post(API_SUGGEST_CODE_URL, data);
    return response.data;
  } catch (error) {
    handleError("Error fetching users:", error);
    throw error;
  }
};

export { fetchUsersApi, updateUserApi, createUserApi, fetchSuggestCodeApi };
